var map = {
	"./033-bm.webp": 1291,
	"./033-cn.webp": 1292,
	"./033.webp": 1293,
	"./13-bm.webp": 1294,
	"./13-cn.webp": 1295,
	"./13.webp": 1296,
	"./3-bm.webp": 1297,
	"./3-cn.webp": 1298,
	"./3.webp": 1299,
	"./angpao-bm.webp": 1300,
	"./angpao-cn.webp": 1301,
	"./angpao.webp": 1302
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1290;